module.exports = __webpack_public_path__ + "img/industry-8.fe4eef31.jpg";